import { useEffect } from "react";

import { useFetchDataFileListing } from "modules/data-files/api";

const useFetchFiles = () => {
  const [data, status, hasNextPage, getNextPage] = useFetchDataFileListing();

  useEffect(() => {
    hasNextPage && getNextPage();
  }, [getNextPage, hasNextPage, data]);

  return { data, status };
};

export default useFetchFiles;
